var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.isViewMode
              ? "查看订单"
              : _vm.orderNo
              ? "编辑订单"
              : "创建订单",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.initloading,
                  expression: "initloading",
                },
              ],
              ref: "pram",
              attrs: { "label-width": "120px", model: _vm.pram },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订单类型：", prop: "type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      on: { change: _vm.changeTypeSelect },
                      model: {
                        value: _vm.pram.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "type", $$v)
                        },
                        expression: "pram.type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("福卡充值"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("权益卡包"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("用户自选"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["blur", "change"],
                      },
                    ],
                    label: "发放小程序：",
                    prop: "appId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择",
                      },
                      on: { change: _vm.handleAppChange },
                      model: {
                        value: _vm.pram.appId,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "appId", $$v)
                        },
                        expression: "pram.appId",
                      },
                    },
                    _vm._l(_vm.appOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.name + "【" + item.id + "】",
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "归属客户：",
                    prop: "customerId",
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        placeholder: "请选择",
                        disabled: true,
                      },
                      model: {
                        value: _vm.pram.customerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "customerId", $$v)
                        },
                        expression: "pram.customerId",
                      },
                    },
                    _vm._l(_vm.cosotmerOption, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.name + "【" + item.id + "】",
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "发放公司：",
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["blur", "change"],
                      },
                    ],
                    prop: "companyId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择发放公司",
                      },
                      model: {
                        value: _vm.pram.companyId,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "companyId", $$v)
                        },
                        expression: "pram.companyId",
                      },
                    },
                    _vm._l(_vm.companyOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "发卡类型：",
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["blur", "change"],
                      },
                    ],
                    prop: "sendType",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择发卡类型 " },
                      model: {
                        value: _vm.pram.sendType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "sendType", $$v)
                        },
                        expression: "pram.sendType",
                      },
                    },
                    _vm._l(_vm.cardTypeOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: "" + item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "订单名称：",
                    prop: "orderName",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.pram.orderName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "orderName", $$v)
                      },
                      expression: "pram.orderName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "项目编号：",
                    prop: "projectNumber",
                    rules: _vm.projectNumberRules,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入项目编号" },
                    model: {
                      value: _vm.pram.projectNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "projectNumber", $$v)
                      },
                      expression: "pram.projectNumber",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "订单数量：",
                    prop: "quantity",
                    rules: [
                      {
                        required: true,
                        message: "请填写订单数量",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      min: 1,
                      precision: 0,
                      step: 1,
                      placeholder: "请输入",
                    },
                    on: { change: _vm.calculateTotalPrice },
                    model: {
                      value: _vm.pram.quantity,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "quantity", $$v)
                      },
                      expression: "pram.quantity",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "销售总价：",
                    prop: "salesPrice",
                    rules: [
                      {
                        required: true,
                        message: "请填写销售总价",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      min: 0,
                      precision: 2,
                      step: 0.01,
                      placeholder: "请输入销售总价",
                    },
                    model: {
                      value: _vm.pram.salesPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "salesPrice", $$v)
                      },
                      expression: "pram.salesPrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.type == 1
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "关联套餐：",
                          prop: "comboId",
                          rules: [
                            {
                              required: true,
                              message: "请选择",
                              trigger: ["blur", "change"],
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              placeholder: "请选择",
                              filterable: "",
                              "filter-method": _vm.handleMealSearch,
                            },
                            on: { change: _vm.selectMeals },
                            model: {
                              value: _vm.pram.comboId,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "comboId", $$v)
                              },
                              expression: "pram.comboId",
                            },
                          },
                          _vm._l(_vm.mealOption, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "套餐单价：",
                          prop: "price",
                          rules: [
                            {
                              required: true,
                              message: "请填写",
                              trigger: ["blur", "change"],
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { min: 0, placeholder: "请输入" },
                          on: { change: _vm.calculateTotalPrice },
                          model: {
                            value: _vm.pram.price,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "price", $$v)
                            },
                            expression: "pram.price",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "对应卡片：",
                          prop: "fuCardId",
                          rules: [
                            {
                              required: true,
                              message: "请选择",
                              trigger: ["blur", "change"],
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              placeholder: "请选择",
                              filterable: "",
                              "filter-method": _vm.handleAgreementSearch,
                            },
                            on: { change: _vm.changeBrand },
                            model: {
                              value: _vm.pram.fuCardId,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "fuCardId", $$v)
                              },
                              expression: "pram.fuCardId",
                            },
                          },
                          _vm._l(_vm.brandOption, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.card_name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.pram.type == 2
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "福卡面值：",
                          prop: "price",
                          rules: [
                            {
                              required: true,
                              message: "请填写",
                              trigger: ["blur", "change"],
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { min: 0, placeholder: "请输入" },
                          on: { change: _vm.calculateTotalPrice },
                          model: {
                            value: _vm.pram.price,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "price", $$v)
                            },
                            expression: "pram.price",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "对应卡片：",
                          prop: "fuCardId",
                          rules: [
                            {
                              required: true,
                              message: "请选择",
                              trigger: ["blur", "change"],
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              placeholder: "请选择",
                              filterable: "",
                              "filter-method": _vm.handleAgreementSearch,
                            },
                            on: { change: _vm.changeBrand },
                            model: {
                              value: _vm.pram.fuCardId,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "fuCardId", $$v)
                              },
                              expression: "pram.fuCardId",
                            },
                          },
                          _vm._l(_vm.brandOption, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.card_name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.pram.type == 3
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "福卡面值：",
                          prop: "price",
                          rules: [
                            {
                              required: true,
                              message: "请填写",
                              trigger: ["blur", "change"],
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请输入" },
                          on: { change: _vm.calculateTotalPrice },
                          model: {
                            value: _vm.pram.price,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "price", $$v)
                            },
                            expression: "pram.price",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "对应权益卡包：",
                          prop: "packageId",
                          rules: [
                            {
                              required: true,
                              message: "请选择",
                              trigger: ["blur", "change"],
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              placeholder: "请选择福卡权益包",
                              filterable: "",
                              "filter-method": _vm.handlePackageSearch,
                            },
                            on: { change: _vm.selectPackage },
                            model: {
                              value: _vm.pram.packageId,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "packageId", $$v)
                              },
                              expression: "pram.packageId",
                            },
                          },
                          [
                            _vm._l(_vm.packageOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            _vm._v(" "),
                            _vm.hasMorePackages
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      cursor: "pointer",
                                      padding: "5px 0",
                                      color: "#409EFF",
                                    },
                                    on: { click: _vm.loadMorePackages },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t查看更多...\n\t\t\t\t\t\t"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.pram.packageId
                      ? _c(
                          "div",
                          { staticClass: "card-distribution-container" },
                          [
                            _c(
                              "div",
                              { staticClass: "card-distribution-header" },
                              [
                                _c("div", { staticClass: "card-title" }, [
                                  _vm._v("对应卡片"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "distribution-title" },
                                  [_vm._v("分配额度")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-divider", {
                              staticStyle: { margin: "10px 0" },
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.relatedCards, function (card, index) {
                              return _c(
                                "div",
                                { key: card.id, staticClass: "card-item" },
                                [
                                  _c("div", { staticClass: "card-info" }, [
                                    _c("span", { staticClass: "card-id" }, [
                                      _vm._v("ID-" + _vm._s(card.id)),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "card-name" }, [
                                      _vm._v(
                                        _vm._s(card.cardName || "卡片名称")
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "card-distribution" },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 0,
                                          precision: 0,
                                          step: 1,
                                          size: "small",
                                          "controls-position": "right",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.updateDistributionValue(
                                              card,
                                              $event
                                            )
                                          },
                                        },
                                        model: {
                                          value: card.distributionValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              card,
                                              "distributionValue",
                                              $$v
                                            )
                                          },
                                          expression: "card.distributionValue",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "unit-label" },
                                        [_vm._v("福豆")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.relatedCards.length === 0
                              ? _c("div", { staticClass: "empty-cards" }, [
                                  _c("i", { staticClass: "el-icon-document" }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("没有关联的卡片")]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.relatedCards.length > 0
                              ? _c("el-divider", {
                                  staticStyle: { margin: "10px 0" },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.relatedCards.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "card-distribution-summary" },
                                  [
                                    _c("div", { staticClass: "summary-item" }, [
                                      _vm._v("\n\t\t\t\t\t\t\t总分配："),
                                      _c(
                                        "span",
                                        { staticClass: "summary-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.totalDistribution) +
                                              "福豆"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "summary-item" }, [
                                      _vm._v("\n\t\t\t\t\t\t\t福卡面值："),
                                      _c(
                                        "span",
                                        { staticClass: "summary-value" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.pram.price) + "福豆"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.distributionWarningVisible
                                      ? _c(
                                          "div",
                                          { staticClass: "warning-message" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-warning",
                                            }),
                                            _vm._v(" "),
                                            parseFloat(_vm.totalDistribution) >
                                            parseFloat(_vm.pram.price)
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t总分配超出福卡面值 " +
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.totalDistribution
                                                        ) -
                                                          parseFloat(
                                                            _vm.pram.price
                                                          )
                                                      ) +
                                                      "福豆\n\t\t\t\t\t\t\t"
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t总分配少于福卡面值 " +
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.pram.price
                                                        ) -
                                                          parseFloat(
                                                            _vm.totalDistribution
                                                          )
                                                      ) +
                                                      "福豆\n\t\t\t\t\t\t\t"
                                                  ),
                                                ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "订单总面额：",
                    prop: "totalPrice",
                    rules: [
                      {
                        required: true,
                        message: "请填写",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      min: 0,
                      placeholder: "自动计算（面值 × 数量）",
                      disabled: true,
                    },
                    model: {
                      value: _vm.pram.totalPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "totalPrice", $$v)
                      },
                      expression: "pram.totalPrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "卡密类型：", prop: "kamiType" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.pram.kamiType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "kamiType", $$v)
                        },
                        expression: "pram.kamiType",
                      },
                    },
                    _vm._l(_vm.kamiTypeOptions, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.value, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "福卡有效期：",
                    prop: "cardTimeRange",
                    rules: [
                      {
                        required: true,
                        message: "请设置福卡有效期",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "form-tip",
                      staticStyle: { "margin-bottom": "5px" },
                    },
                    [
                      _vm._v(
                        "指兑换后福卡的有效时间（系统默认当前时间起 3 年内）"
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetimerange",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "range-separator": "-",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      editable: false,
                    },
                    model: {
                      value: _vm.pram.cardTimeRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "cardTimeRange", $$v)
                      },
                      expression: "pram.cardTimeRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "订单备注：", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请输入",
                    },
                    model: {
                      value: _vm.pram.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "remark", $$v)
                      },
                      expression: "pram.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "内部备注：", prop: "innerRemark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "内部备注（仅后台可见）",
                    },
                    model: {
                      value: _vm.pram.innerRemark,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "innerRemark", $$v)
                      },
                      expression: "pram.innerRemark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "状态变更：",
                    prop: "status",
                    rules: [
                      {
                        required: true,
                        message: "请选择订单状态",
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "请选择订单状态",
                        disabled: _vm.isViewMode,
                      },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    _vm._l(_vm.currentStatusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              [0, 1].includes(_vm.details.status) || !_vm.details.status
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.handerSubmit("pram")
                        },
                      },
                    },
                    [_vm._v("确认")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }